<template>
  
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="功能名称：">
            <el-input v-model="query.functionName" placeholder="请输入功能名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="位置：">
            <el-select v-model="query.functionType" placeholder="请选择" clearable size="small">
              <el-option label="首页" :value="1"></el-option>
              <el-option label="患者管理" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="query.functionStatus" placeholder="请选择" clearable size="small">
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div style="margin-bottom: 15px;">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleCreate">新增</el-button>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange">
        <el-table-column label="功能名称" prop="functionName" align="center"  />
        <el-table-column label="位置" prop="functionType" align="center">
          <template slot-scope="{row}">
            {{ row.functionType === 1 ? '首页' : row.functionType === 2 ? '患者管理' : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="图片" prop="functionImg" align="center">
          <template slot-scope="{row}">
            <el-image style="width: 50px; height: 50px" :src="row.icon" :preview-src-list="[row.icon]" ></el-image>
          </template>
        </el-table-column>
        <el-table-column label="排序" prop="orderNo" align="center" />
        <el-table-column label="是否登录首页展示" prop="isLoginVisible" align="center">
          <template slot-scope="{row}">
            <!-- <el-switch v-model="row.isLoginVisible" :active-value="1" :inactive-value="0"  @change="changeLoginSwitch(row)">
            </el-switch> -->
            {{ row.isLoginVisible ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="state" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.functionStatus" :active-value="1" :inactive-value="0"  @change="changeSwitch(row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="修改时间" prop="operatedTime" sortable align="center"></el-table-column>
        <el-table-column label="操作人" prop="operatedPeople" align="center"></el-table-column>
        <el-table-column label="操作" align="center" fixed="right" >
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row,1)">编辑</el-button>
            <!-- <el-button type="text">日志记录</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <functionType-add ref="functionTypeAdd" @created="doQueryList({})" :popType="popType" />
  </div>
</template>

<script>
import functionTypeAdd from './add'
import functionTypesApi from '@/api/marketing/functionTypes'
import Pagination from '@/components/Pagination'

// 【项目落地】专属页：只列出首页功能区里名为「项目落地」的那一个入口
//（home_function_area 表 code='project_landing' 那行）。
// 数据不迁移、不复制，仍由这张表统一存放；本页只是把列表过滤到这一行。
// 专属菜单页锁定的是「项目落地 App 入口」这一条固定记录。
// 原来用功能名称('项目落地')做筛选，运营把入口改名（如改成「项目推广」）后
// 名称不再匹配，整条记录就从列表里消失、图标也跟着空白。
// code 是这条记录的稳定业务标识，改名不会变，用它筛才不会丢。
const FUNCTION_CODE_PROJECT_LANDING = 'project_landing'
export default {
  components: {
    Pagination,
    functionTypeAdd
  },
  data() {
    return {
      popType: 0, //0:新增 1:编辑
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        functionType: 1,
        code: FUNCTION_CODE_PROJECT_LANDING,
        functionStatus: '',
        orderNoSortSign: 1
      },
      selectItems: [],
      activeName: '1',
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 列表tab切换
     */
    handleClick() {
      console.log('val: ', this.activeName);
    },

    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 重置
     */
    handleFilter() {
      // 重置回到进页面时的状态：专属菜单里要保留预置的功能名过滤词，否则一重置就漏出全部入口
      this.query.code = FUNCTION_CODE_PROJECT_LANDING
      this.query.functionName = ''
      this.query.functionType = 1
      this.query.functionStatus = ''
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 获取列表数据
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      return functionTypesApi.fetchList(this.query)
        .then(res => {
          res.data.list.forEach(item => {
            item.showTime = item.isLimit ? `${item.startTime.substring(0, 16)}--${item.endTime.substring(0, 16)}` : '-';
            item.times = item.isLimit ? [item.startTime, item.endTime] : '';
          })
          this.list = res.data.list
          this.total = res.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => functionTypesApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({
            pageNo: 1
          })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择活动')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => functionTypesApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({
            pageNo: 1
          })
        })
    },
    /**
     * 批量上下架
     */
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择充值活动')
        return
      }
      let ids = this.selectItems.map(row => row.id)
      let txt = ""
      this.handleBatchState(ids, command.command)
    },
    handleBatchState(ids, type) {
      let txt = type ? '确认将选中充值活动批量上架？' : '确认将选中充值活动批量下架？'
      this.$common.confirm(txt).then(() => functionTypesApi.updateState({ rechargeIdStr: ids.join(','), state: type }))
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
      /**
       * 单个上下架
       */
      changeSwitch(row) {
        return functionTypesApi.update({ ...row, functionStatus: row.functionStatus }).then(() => {
          this.$common.showMsg('success', '操作成功')
        })
      },

    changeLoginSwitch(row) {
      return functionTypesApi.update({ ...row, isLoginVisible: row.isLoginVisible }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },

    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.functionTypeAdd.handleCreate(row)
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$emit('handleShow', row, 2)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.functionTypeAdd.handleUpdate(row)
    },
    handleDownload() {
      return this.$common.confirm('是否确认导出')
        .then(() => sysGoodsApi.exportExcel(this.query))
    },
  }
}
</script>
